import React from "react";
import { validationUtils } from "../validation/Validation";
import { ValidatableFormGroup } from "../components/ValidatableFormGroup"
import { IEftInfo, IPaymentInfoChangeResult } from "../classes/Domain";
import Utilities from "../classes/Utilities";
import _ from "lodash";

interface IProps {
    eft: IEftInfo,
    onChange(result: IPaymentInfoChangeResult): void,
    disabled?: boolean,
    errors: any
}

interface IState {

}

class Eft extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    onEftChange(value: string, prop: string) {
        const updatedEft = { ...this.props.eft, instrumentType: "EFT" } as IEftInfo;
        updatedEft[prop] = value;

        this.props.onChange({ paymentInstrument: updatedEft });
    }

    render() {
        return (<div>
            <ValidatableFormGroup
                label="Bank Name To Withdraw Funds From"
                value={Utilities.getStringValueSafe(this.props.eft, "bankName") || ""}
                placeholder="Bank Name To Withdraw Funds From"
                disabled={this.props.disabled}
                validated={null !== this.props.errors}
                validationError={validationUtils.getValidationErrorFor(this.props.errors, "bankName")}
                onChange={(e) => { this.onEftChange(e.target.value, "bankName") }} />

            <ValidatableFormGroup
                label="Routing #"
                value={Utilities.getStringValueSafe(this.props.eft, "transitNumber") || ""}
                placeholder="Routing #"
                disabled={this.props.disabled}
                validated={null !== this.props.errors}
                validationError={validationUtils.getValidationErrorFor(this.props.errors, "transitNumber")}
                onChange={(e) => { this.onEftChange(e.target.value, "transitNumber") }} />

            <ValidatableFormGroup
                label="Account #"
                value={Utilities.getStringValueSafe(this.props.eft, "accountNumber") || ""}
                placeholder="Account #"
                disabled={this.props.disabled}
                validated={null !== this.props.errors}
                validationError={validationUtils.getValidationErrorFor(this.props.errors, "accountNumber")}
                onChange={(e) => { this.onEftChange(e.target.value, "accountNumber") }} />
        </div>);
    }
}

export default Eft;